import { Box, Stack, Typography, styled } from "@mui/material";
import { prefixClassName } from "@smartrr/shared/components/primitives";
import { AquariusCard } from "@smartrr/shared/customerPortal/components/AquariusCard";
import { isIsoDate } from "@smartrr/shared/utils/dateUtils";
import { typedLocalize } from "@smartrr/shared/utils/sharedTranslations/localize";
import * as icons from "akar-icons";
import React, { useEffect, useState } from "react";

import { useToggleModal } from "@customer-app/state/actionCreators/modal";
import { useSmartrrCustomerSelector } from "@customer-app/state/typedCustomerReduxHooks";

const LineWrapper = styled("span")<{ subdued?: boolean }>`
  cursor: ${props => (props.onClick ? "pointer" : "auto")};
  text-decoration: ${props => (props.onClick ? "underline" : "none")};

  p {
    opacity: ${props => (props.subdued ? "70%" : "100%")};
  }

  svg {
    height: 14px;
    stroke: ${props => props.theme.modernIconsColor};
    width: 14px;
  }
`;

interface IPersonalInfoLines {
  Icon: icons.Icon;
  onClick?: () => void;
  label: string;
  subdued?: boolean;
}

const PersonalInfoLine = ({ Icon, label, onClick, subdued }: IPersonalInfoLines): JSX.Element => (
  <React.Fragment>
    {Icon ? (
      <LineWrapper onClick={onClick} subdued={subdued}>
        <Stack direction="row" spacing="7px" display="flex" alignItems="center">
          <Icon />
          <Typography variant="body1">{label}</Typography>
        </Stack>
      </LineWrapper>
    ) : (
      <React.Fragment />
    )}
  </React.Fragment>
);

export const PersonalInfo = (): JSX.Element => {
  const customerAuth = useSmartrrCustomerSelector(state => state.auth);
  const { birthdayDate } = customerAuth.customerRelationship!;
  const { email } = customerAuth.liquidCustomer!;

  const [_, setCustomerBirthdayString] = useState<string>();

  const toggleModal = useToggleModal();

  useEffect(() => {
    if (isIsoDate(birthdayDate)) {
      setCustomerBirthdayString(
        typedLocalize("utils.dates.toViewDateBirthday", {
          date: new Date(birthdayDate),
        })
      );
    }
  }, [birthdayDate]);

  return (
    <AquariusCard
      sx={{ height: "100%", display: "flex", justifyContent: "space-between", flexDirection: "column" }}
      className={prefixClassName("personal-info")}
    >
      <Box marginBottom={"5px"} className={prefixClassName("personal-info-container")}>
        <Typography variant="h4" className={prefixClassName("personal-info-title")}>
          {typedLocalize("settings.personalInformation.title")}
        </Typography>
        <Stack spacing="15px" direction="column">
          <PersonalInfoLine
            Icon={icons.Envelope}
            label={email ?? ""}
            onClick={() => toggleModal("CHANGE_EMAIL", { email })}
          />
        </Stack>
      </Box>
    </AquariusCard>
  );
};
